import { formatPrice } from '@utils/prices';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import { Bid } from '../../../../components/Checkout/Bid';
import { useCheckoutCtx } from '../../../../providers/CheckoutProvider';

export const PlaceBid = () => {
  const {
    acceptsBid,
    artistName,
    bid,
    currencyCode,
    minimumBid,
    placeBid,
    step,
    summaryProps,
  } = useCheckoutCtx();
  const { t } = useTranslation('checkout');
  const [value, setValue] = useState(bid === null ? '' : String(bid));
  const [showError, setShowError] = useState(bid !== null);

  const amount = Number(value);
  const accepted = value.trim() !== '' && acceptsBid(amount);

  const handleSubmit = () => {
    if (!accepted) {
      setShowError(true);
      return;
    }

    placeBid(amount);
    step.goNext();
  };

  return (
    <Bid
      artistName={artistName}
      currencyCode={currencyCode}
      error={
        showError && !accepted
          ? t('bid.tooLow', {
              amount: formatPrice(minimumBid, currencyCode),
            })
          : undefined
      }
      minimumBid={minimumBid}
      onChange={(nextValue) => {
        setValue(nextValue);
        setShowError(false);
      }}
      onSubmit={handleSubmit}
      summaryProps={summaryProps}
      value={value}
    />
  );
};
